



























































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";

@Component
export default class EditPreferenzaWorkshop extends Vue {
  @Prop() info!: any;
  @Prop() checkInfo!: any;
  @Prop() idIstituto!: number;

  private articolazioni: any;
  private scelte: any;
  private newArticolazione: string;
  private newScelta: string;

  private lastname: string;
  private name: string;
  private email: string;

  private lastnameRules: [boolean | string];
  private nameRules: [boolean | string];
  private emailRules: [boolean | string];

  constructor() {
    super();
    this.articolazioni = [];
    this.newArticolazione = this.info.idArticolazione;
    this.newScelta = this.info.scelta;
    this.scelte = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "più di 10"
    ];
    this.lastname = this.info.cognomeReferente;
    this.name = this.info.nomeReferente;
    this.email = this.info.emailReferente;

    this.lastnameRules = [true];
    this.nameRules = [true];
    this.emailRules = [true];
  }

  validazioneCognome() {
    var valid: boolean = false;
    if (this.lastname !== "" || this.lastname !== null) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.lastname);
    }
    if (valid) {
      this.lastnameRules = [true];
    } else if (this.lastname === "") {
      this.lastnameRules = ["Cognome Referente necessario"];
    } else {
      this.lastnameRules = [
        "Cognome Referente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneNome() {
    var valid: boolean = false;
    if (this.name !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.name);
    }
    if (valid) {
      this.nameRules = [true];
    } else if (this.name === "") {
      this.nameRules = ["Nome Referente necessario"];
    } else {
      this.nameRules = [
        "Nome Referente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }

  validazioneEmail() {
    var valid: boolean = false;
    if (this.email !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(this.email);
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.email === "") {
      this.emailRules = ["Email Referente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }

  loadArticolazioni() {
    var articolazione = {
      idArticolazione: "",
      nomArticolazione: ""
    };
    var articolazioni: any[] = [];
    data
      .dispatchArticolazioni(this["$store"], this.idIstituto)
      .then(response => {
        response.forEach(function(element: any) {
          articolazione = {
            idArticolazione: element.idArticolazione,
            nomArticolazione: element.nomeArticolazione
          };
          articolazioni.push(articolazione);
        });
        this.articolazioni = articolazioni;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  close() {
    this.articolazioni = this.articolazioni;
    this.newArticolazione = this.info.idArticolazione;
    this.newScelta = this.info.scelta;
    this.scelte = ["1", "2", "più di 2", "tra 5 e 10", "più di 10"];
    this.lastnameRules = [true];
    this.nameRules = [true];
    this.emailRules = [true];
    bus.$emit("closeEditDialog");
  }

  async executeTest() {
    this.validazioneCognome();
    this.validazioneNome();
    this.validazioneEmail();
  }

  save() {
    var alreadyExist: boolean = false;
    var nuovaPreferenza = {
      idInformazione: this.info.idInformazioneWorkshop,
      articolazione: this.newArticolazione,
      scelta: this.newScelta,
      nomeReferente: this.name,
      cognomeReferente: this.lastname,
      emailReferente: this.email
    };
    alreadyExist = this.checkInfo.some(
      (preferenza: any) =>
        preferenza["idArticolazione"] === this.newArticolazione
    );
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        user
          .dispatchUpdatePreferenzaWorkshop(this["$store"], nuovaPreferenza)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Preferenza Modificata con successo"
            );
            this.close();
            bus.$emit("loadPreferenzeWorkshop");
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
    // if (alreadyExist) {
    //   bus.$emit(
    //     "errorOperation",
    //     "Preferenza per il settore selezionato già indicata"
    //   );
    // } else {
    //   this.executeTest().then(() => {
    //     if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
    //       user
    //         .dispatchUpdatePreferenzaWorkshop(this["$store"], nuovaPreferenza)
    //         .then(() => {
    //           bus.$emit(
    //             "successfullOperation",
    //             "Preferenza Modificata con successo"
    //           );
    //           this.close();
    //           bus.$emit("loadPreferenzeWorkshop");
    //         })
    //         .catch(error => {
    //           if (error.response.status === 403) {
    //             bus.$emit("errorOperation", error.response.statusText);
    //             this["$router"].push("/login");
    //           } else {
    //             bus.$emit("errorOperation", error.response.statusText);
    //           }
    //         });
    //     }
    //   });
    // }
  }

  created() {
    this.loadArticolazioni();
  }
}
